import session from './session'
import file from './file'

var uri = process.env.API_ENDPOINT

export default {
  login (email, password) {
    return session.post(uri + '/api/user/login/', { email, password })
      .then(() => {
      })
      .catch((e) => {
        console.error('e: ' + JSON.stringify(e))
        throw JSON.stringify(e.response["data"]["error"])
      })
  },
  tokenLogin (email, password) {
    return session.post(uri + '/api/login/', { email, password })
  },
  logout () {
    return session.get(uri + '/api/user/logout/', {})
  },
  loginResetRequest (payload) {
    return session.post(uri + '/api/user/login_lock_reset/', payload)
  },
  getLoginResetUser (user_id) {
    return session.get(uri + '/api/user/login_lock_reset/' + user_id + '/')
  },
  login_reset (payload) {
    return session.patch(uri + '/api/user/login_lock_reset/', payload)
  },
  messageLogin (tel,seeker_id) {
    return session.post(uri + '/api/user/message_login/', { tel, seeker_id })
  },
  getMessageCompany (company_id) {
    return session.get(uri + '/api/user/message_company/' + company_id)
  },
  repossessionSeeker (seeker_id) {
    return session.get(uri + '/api/user/repossessionseeker/' + seeker_id)
  },
  createPreAccount (data) {
    return session.post(uri + '/api/user/pre_register/', data)
  },
  createAccount (data) {
    return session.post(uri + '/api/user/register/', data)
  },
  createProfileData (data) {
    return session.post(uri + '/api/user/profile_data/', data)
  },
  changeAccountPassword (password1, password2) {
    return session.post(uri + '/api/auth/password/change/', { password1, password2 })
  },
  addMember (data) {
    return session.post(uri + '/api/user/addmember/', data)
  },
  reAddMember (data) {
    return session.post(uri + '/api/user/re_addmember/', data)
  },
  getUsers () {
    return session.get(uri + '/api/user/get_users/')
  },
  setUsers (data) {
    return session.put(uri + '/api/user/set_users/', data)
  },
  setUserConnect (data) {
    return session.put(uri + '/api/user/set_user/connect/', data)
  },
  getDeactivatedUsers () {
    return session.get(uri + '/api/user/get_deactivated_users/')
  },
  setProfile (data, type) {
    return session.put(uri + '/api/user/set_user/' + type + '/', data)
  },
  setProfileUser (data, type) {
    return session.put(uri + '/api/user/set_user_u/' + type + '/', data)
  },
  setProfileSeekerInfo (data) {
    return session.put(uri + '/api/user/set_user/seeker_info/', data)
  },
  setUserIcon (name, data) {
    return file.put(uri + '/api/user/set_user_icon/', {name: name, icon: data})
  },
  setIconImage (name, data) {
    return session.put(uri + '/api/user/set_icon_image/', {name: name, icon: data})
  },
  setColor (color) {
    return session.put(uri + '/api/user/set_icon_color/', color)
  },
  setPower (data) {
    return session.put(uri + '/api/user/set_power/', data)
  },
  setCompanyIcon (data) {
    return file.put(uri + '/api/user/set_company_icon/', data)
  },
  companyPageSave (file) {
    return session.put(uri + '/api/user/set_company_page_save/', file)
  },
  resetAccountPassword (uid, token, new_password1, new_password2) {
    return session.post(uri + '/auth/password/reset/confirm/', { uid, token, new_password1, new_password2 })
  },
  getAccountDetails () {
    return session.get(uri + '/api/user/mypage/')
  },
  getAccountDetailsUser () {
    return session.get(uri + '/api/user/mypage_u/')
  },
  updateAccountDetails (data) {
    return session.patch(uri + '/auth/user/', data)
  },
  verifyAccountEmail (key) {
    return session.post(uri + '/registration/verify-email/', { key })
  },
  setSlack (code, cid, sec, on) {
    var flg = ''
    if (on) {
      flg = 'on'
    } else {
      flg = 'off'
    }
    return session.get(uri + '/api/user/slack' + '?code=' + code + '&company_key=' + cid + '&sec=' + sec + '&flg=' + flg) // eslint-disable-line
  },
  getSlack (cid) {
    return session.get(uri + '/api/user/get_slack_status' + '?company_key=' + cid)
  },
  postSlack (cid, id, msg) {
    return session.post(uri + '/api/user/post_slack' + '?company_key=' + cid + '&id=' + id, {'msg': msg})
  },
  updateSlack (slack) {
    return session.patch(uri + '/api/user/update_slack/', slack)
  },
  deleteSlackLink () {
    return session.delete(uri + '/api/user/delete_slack_link/')
  },
  setCW (code, cid, sec, on) {
    var flg = ''
    if (on) {
      flg = 'on'
    } else {
      flg = 'off'
    }
    return session.get(uri + '/api/user/cw' + '?code=' + code + '&company_key=' + cid + '&sec=' + sec + '&flg=' + flg) // eslint-disable-line
  },
  getCW (cid) {
    return session.get(uri + '/api/user/get_cw_status' + '?company_key=' + cid)
  },
  putCW (data) {
    return session.put(uri + '/api/user/put_cw', data)
  },
  postCW (cid, id, msg) {
    return session.post(uri + '/api/user/post_cw' + '?company_key=' + cid + '&id=' + id, {'msg': msg})
  },
  updateCW (cw) {
    return session.patch(uri + '/api/user/update_cw/', cw)
  },
  deleteCWLink () {
    return session.delete(uri + '/api/user/delete_cw_link/')
  },
  getWT (cid) {
    return session.get(uri + '/api/user/get_wt_status' + '?company_key=' + cid)
  },
  putWT (data) {
    return session.put(uri + '/api/user/put_wt/', data)
  },
  postWT (cid, id, msg) {
    return session.post(uri + '/api/user/post_wt' + '?company_key=' + cid + '&id=' + id, {'msg': msg})
  },
  postWTLink (wt) {
    return session.post(uri + '/api/user/post_wt_link', wt)
  },
  deleteWTLink () {
    return session.delete(uri + '/api/user/delete_wt_link/')
  },
  createCard (data) {
    return session.post(uri + '/api/user/card/create/', data)
  },
  setCard (data) {
    return session.put(uri + '/api/user/card/set/', data)
  },
  setCardsOrder (data) {
    return session.put(uri + '/api/user/cards/set/', data)
  },
  createFavorite (data) {
    return session.post(uri + '/api/user/fv/create/', data)
  },
  setFavorite (data) {
    return session.put(uri + '/api/user/fv/set/', data)
  },
  sendRH (data) {
    return session.post(uri + '/api/user/request/help/', data)
  },
  sendPR (data) {
    return session.post(uri + '/api/user/password/reset/', data)
  },
  checkToken (id) {
    return session.get(uri + '/api/user/password/reset/check/' + id)
  },
  reIssue (id) {
    return session.put(uri + '/api/user/password/reset/re_issue/' + id)
  },
  reCreatePassword (data, id) {
    return session.put(uri + '/api/user/password/reset/recreate/' + id, data)
  },
  getCompanyList () {
    return session.get(uri + '/api/user/company_list/get')
  },
  updateUserCompany (companyID) {
    return session.put(uri + '/api/user/user_company/update/' + companyID)
  },
  googleAuthRevoke (email) {
    return session.delete(uri + '/api/user/google_revoke/' + email + '/')
  },
  googleDriveAuthRevoke (email) {
    return session.delete(uri + '/api/user/google_drive_revoke/' + email + '/')
  },
  getGoogleDriveAuthStatus () {
    return session.get(uri + '/api/user/get_google_drive_status/')
  },
  msofficeAuthRevoke () {
    return session.delete(uri + '/api/user/msoffice_revoke/')
  },
  getLineChannelInfo() {
    return session.get(uri + '/api/user/line_channel/')
  },
  setLineChannelInfo(data) {
    return session.put(uri + '/api/user/line_channel/', data)
  },
  deleteLineChannelInfo() {
    return session.delete(uri + '/api/user/line_channel/')
  },
  getSearch (searchWord) {
    return session.get(uri + '/api/user/get_search/' + searchWord)
  },
  async sendSubscribe (data) {
    return session.post(uri + '/api/user/send/subscribe/', data)
  },
  demoImage (data) {
    return session.post(uri + '/api/user/demo_image/', data)
  },
  compnayPageCapture () {
    return session.get(uri + '/api/user/capture_page/')
  },
  sendMessage (data) {
    return session.post(uri + '/api/user/send/conversion/', data)
  },
  async sendSubscribeNoData(data) {
    return session.post(uri + '/api/user/send/subscribe_no/', data)
  },
  createTopLPUser (data) {
    return session.post(uri + '/api/user/top_lp/', data)
  },
  // TODO:合言葉は別処理にすること
  getVideoInterviewInfo (id) {
    return session.get(uri + '/api/user/get_video_interview_info/' + id + '/')
  },
  getStoreCateogry () {
    return session.get(uri + '/api/user/store_category/0')
  },
  putStoreCateogry (data) {
    return session.put(uri + '/api/user/store_category/0', data)
  },
  postStoreCateogry (data) {
    return session.post(uri + '/api/user/store_category/0', data)
  },
  deleteStoreCateogry (id) {
    return session.delete(uri + '/api/user/store_category/' + id)
  },
  sendEntryEmail(data) {
    return session.post(uri + '/api/user/send_entry_email/', data)
  },
  // Company Recruit API
  createCompanyRecruit (data) {
    return session.post(uri + '/api/user/company_recruit/', data)
  },
  getCompanyRecruit (id) {
    if (id) return session.get(uri + '/api/user/company_recruit/' + id)
    else return session.get(uri + '/api/user/company_recruit/')
  },
  getDisplayCompanyRecruit (data) {
    return session.post(uri + '/api/user/display_company_recruit/', data)
  },
  getMediaCooperationList (data) {
    return session.get(uri + '/api/user/get_media_cooperation_list/')
  },
  updateCompanyRecruit (data) {
    return session.patch(uri + '/api/user/company_recruit/', data)
  },
  deleteCompanyRecruit (id) {
    return session.delete(uri + '/api/user/company_recruit/' + id)
  },
  // Email Template API
  createCompanyEmailTemplate (data) {
    return session.post(uri + '/api/user/company_email_template/', data)
  },
  getCompanyEmailTemplate (id) {
    if (id) return session.get(uri + '/api/user/company_email_template/' + id)
    else return session.get(uri + '/api/user/company_email_template/')
  },
  updateCompanyEmailTemplate (data) {
    return session.patch(uri + '/api/user/company_email_template/', data)
  },
  deleteCompanyEmailTemplate (id) {
    return session.delete(uri + '/api/user/company_email_template/' + id)
  },
  updateOrderCompanyEmailTemplate (data) {
    return session.put(uri + '/api/user/company_email_template_order/', data)
  },
  // Email(SMS) Template API
  createCompanySMSTemplate (data) {
    return session.post(uri + '/api/user/company_sms_template/', data)
  },
  getCompanySMSTemplate (id) {
    if (id) return session.get(uri + '/api/user/company_sms_template/' + id)
    else return session.get(uri + '/api/user/company_sms_template/')
  },
  updateCompanySMSTemplate (data) {
    return session.patch(uri + '/api/user/company_sms_template/', data)
  },
  deleteCompanySMSTemplate (id) {
    return session.delete(uri + '/api/user/company_sms_template/' + id)
  },
  // CompanyColumnSetting API
  createCompanyColumnSetting (data) {
    return session.post(uri + '/api/user/company_column_setting/', data)
  },
  getCompanyColumnSetting (id) {
    if (id) return session.get(uri + '/api/user/company_column_setting/' + id)
    else return session.get(uri + '/api/user/company_column_setting/')
  },
  updateCompanyColumnSetting (data) {
    return session.patch(uri + '/api/user/company_column_setting/', data)
  },
  deleteCompanyColumnSetting (id) {
    return session.delete(uri + '/api/user/company_column_setting/' + id)
  },
  // CompanyPulldownColumn API
  createCompanyPulldownColumn(data) {
    return session.post(uri + '/api/user/company_pulldown_column/', data);
  },
  updateCompanyPulldownColumn(data) {
    return session.patch(uri + '/api/user/company_pulldown_column/' + data.id + '/', data);
  },
  deleteCompanyPulldownColumn(id) {
    return session.delete(uri + '/api/user/company_pulldown_column/' + id + '/');
  },
  fetchCompanyPulldownColumns(columnId) {
    return session.get(uri + '/api/user/company-pulldown-column/' + columnId + '/');
  },
  // UserCustomColumns API
  createUserCustomColumns(data) {
    return session.post(uri + '/api/user/user_custom_columns/', data)
  },
  getUserCustomColumns(id) {
    if (id) return session.get(uri + '/api/user/user_custom_columns/' + id)
    else return session.get(uri + '/api/user/user_custom_columns/')
  },
  updateUserCustomColumns(data) {
    return session.patch(uri + '/api/user/user_custom_columns/', data)
  },
  deleteUserCustomColumns(id) {
    return session.delete(uri + '/api/user/user_custom_columns/' + id)
  },
  // DetailSheet API
  getDetailSheetTemplateList() {
    return session.get(uri + '/api/user/detail_sheet_template_list/')
  },
  setDetailSheetTemplateList(data) {
    return session.post(uri + '/api/user/detail_sheet_template_list/', data)
  },
  getDetailSheetColumnList(template_id) {
    return session.get(uri + '/api/user/detail_sheet_column_list/in/' + template_id + '/')
  },
  setDetailSheetColumnList(template_id, data) {
    return session.post(uri + '/api/user/detail_sheet_column_list/in/' + template_id + '/', data)
  },
  // Scout API
  createScout (data) {
    return session.post(uri + '/api/user/scout/', data)
  },
  getScout (id) {
    if (id) return session.get(uri + '/api/user/scout/' + id)
    else return session.get(uri + '/api/user/scout/')
  },
  updateScout (data) {
    return session.patch(uri + '/api/user/scout/', data)
  },
  deleteScout (id) {
    return session.delete(uri + '/api/user/scout/' + id)
  },
  // RecruitmentFlow API
  createRecruitmentFlow (data) {
    return session.post(uri + '/api/user/recruit_flow/', data)
  },
  getRecruitmentFlow (id) {
    if (id) return session.get(uri + '/api/user/recruit_flow/' + id)
    else return session.get(uri + '/api/user/recruit_flow/')
  },
  updateRecruitmentFlow (data) {
    return session.patch(uri + '/api/user/recruit_flow/', data)
  },
  deleteRecruitmentFlow (id) {
    return session.delete(uri + '/api/user/recruit_flow/' + id)
  },
  // RecruitmentFlowStage API
  createRecruitmentFlowStage (data) {
    return session.post(uri + '/api/user/recruit_flow_stage/', data)
  },
  getRecruitmentFlowStage (id) {
    if (id) return session.get(uri + '/api/user/recruit_flow_stage/' + id)
    else return session.get(uri + '/api/user/recruit_flow_stage/')
  },
  updateRecruitmentFlowStage (data) {
    return session.patch(uri + '/api/user/recruit_flow_stage/', data)
  },
  deleteRecruitmentFlowStage (id) {
    return session.delete(uri + '/api/user/recruit_flow_stage/' + id)
  },
  // CreateManage API
  createManage (data) {
    return session.post(uri + '/api/user/create_manage/', data)
  },
  async getcreateManage (id) {
    if(id) return session.get(uri + '/api/user/create_manage/' + id)
    else return session.get(uri + '/api/user/create_manage/')
  },
  // UpdateManage API
  updateManage (data) {
    return session.put(uri + '/api/user/update_manage/' + data.pk + '/', data)
  },
  // DeleteManage API
  deleteManage (id) {
    return session.delete(uri + '/api/user/delete_manage/' + id + '/')
  },
  getManageDeletionImpact (id) {
    return session.get(uri + '/api/user/manage_deletion_impact/' + id + '/')
  },
  // RecruitmentFlowStatus API
  createRecruitmentFlowStatus (data) {
    return session.post(uri + '/api/user/recruit_flow_status/', data)
  },
  getRecruitmentFlowStatus (id) {
    if (id) return session.get(uri + '/api/user/recruit_flow_status/' + id)
    else return session.get(uri + '/api/user/recruit_flow_status/')
  },
  updateRecruitmentFlowStatus (data) {
    return session.patch(uri + '/api/user/recruit_flow_status/', data)
  },
  deleteRecruitmentFlowStatus (id) {
    return session.delete(uri + '/api/user/recruit_flow_status/' + id)
  },
  // RecruitmentFlowAction API
  createRecruitmentFlowAction (data) {
    return session.post(uri + '/api/user/recruit_flow_action/', data)
  },
  getRecruitmentFlowAction (id) {
    if (id) return session.get(uri + '/api/user/recruit_flow_action/' + id)
    else return session.get(uri + '/api/user/recruit_flow_action/')
  },
  updateRecruitmentFlowAction (data) {
    return session.patch(uri + '/api/user/recruit_flow_action/', data)
  },
  deleteRecruitmentFlowAction (id) {
    return session.delete(uri + '/api/user/recruit_flow_action/' + id)
  },
  // initial recruitFlow
  initialCreateRecruitmentFlow () {
    return session.post(uri + '/api/user/init_recruit_flow/')
  },
  getFollow(id) {
    return session.get(uri + '/api/user/get_follow/' + id)
  },
  getFollowInfo() {
    return session.get(uri + '/api/user/get_follow_info/')
  },
  addFollow(data) {
    return session.post(uri + '/recruit/add_follow', data)
  },
  deleteFollow(data) {
    return session.post(uri + '/recruit/delete_follow', data)
  },
  // Department API
  createDepartment (data) {
    return session.post(uri + '/api/user/department/', data)
  },
  bulkCreateDepartment (data) {
    return session.post(uri + '/api/user/bulk_department/', data)
  },
  getDepartment (id) {
    if (id) return session.get(uri + '/api/user/department/' + id)
    else return session.get(uri + '/api/user/department/')
  },
  updateDepartment (data) {
    return session.patch(uri + '/api/user/department/' + data.pk, data)
  },
  deleteDepartment (id) {
    return session.delete(uri + '/api/user/department/' + id)
  },
  // Position API
  createPosition (data) {
    return session.post(uri + '/api/user/position/', data)
  },
  bulkCreatePosition (data) {
    return session.post(uri + '/api/user/bulk_position/', data)
  },
  getPosition (id) {
    if (id) return session.get(uri + '/api/user/position/' + id)
    else return session.get(uri + '/api/user/position/')
  },
  updatePosition (data) {
    return session.patch(uri + '/api/user/position/' + data.pk, data)
  },
  deletePosition (id) {
    return session.delete(uri + '/api/user/position/' + id)
  },
  // CalendarBookMark API
  createCalendarBookMark (data) {
    return session.post(uri + '/api/user/calendar_bookmark/', data)
  },
  getCalendarBookMark (id) {
    if (id) return session.get(uri + '/api/user/calendar_bookmark/' + id)
    else return session.get(uri + '/api/user/calendar_bookmark/')
  },
  updateCalendarBookMark (data) {
    return session.patch(uri + '/api/user/calendar_bookmark/' + data.pk, data)
  },
  deleteCalendarBookMark (id) {
    return session.delete(uri + '/api/user/calendar_bookmark/' + id)
  },
  // UserCalendarSetting API
  createUserCalendarSetting (data) {
    return session.post(uri + '/api/user/calendar_setting/', data)
  },
  getUserCalendarSetting (id) {
    if (id) return session.get(uri + '/api/user/calendar_setting/' + id)
    else return session.get(uri + '/api/user/calendar_setting/')
  },
  updateUserCalendarSetting (data) {
    return session.patch(uri + '/api/user/calendar_setting/' + data.pk, data)
  },
  deleteUserCalendarSetting (id) {
    return session.delete(uri + '/api/user/calendar_setting/' + id)
  },
  // UserCalendarEventHistory API
  createUserCalendarEventHistory (data) {
    return session.post(uri + '/api/user/calendar_event_history/', data)
  },
  getUserCalendarEventHistory (id) {
    if (id) return session.get(uri + '/api/user/calendar_event_history/' + id)
    else return session.get(uri + '/api/user/calendar_event_history/')
  },
  updateUserCalendarEventHistory (data) {
    return session.patch(uri + '/api/user/calendar_event_history/' + data.pk, data)
  },
  deleteUserCalendarEventHistory (id) {
    return session.delete(uri + '/api/user/calendar_event_history/' + id)
  },
  // UserChatBotBookMark API
  createUserChatBotBookMark (data) {
    return session.post(uri + '/api/user/user_chatbot_bookmark/', data)
  },
  getUserChatBotBookMark (id) {
    if (id) return session.get(uri + '/api/user/user_chatbot_bookmark/' + id)
    else return session.get(uri + '/api/user/user_chatbot_bookmark/')
  },
  updateUserChatBotBookMark (data) {
    return session.patch(uri + '/api/user/user_chatbot_bookmark/' + data.pk, data)
  },
  deleteUserChatBotBookMark (id) {
    return session.delete(uri + '/api/user/user_chatbot_bookmark/' + id)
  },
  // ScoutFiltering API
  createScoutFiltering (data) {
    return session.post(uri + '/api/user/scout_filtering/', data)
  },
  getScoutFiltering (id) {
    if (id) return session.get(uri + '/api/user/scout_filtering/' + id)
    else return session.get(uri + '/api/user/scout_filtering/')
  },
  updateScoutFiltering (data) {
    return session.patch(uri + '/api/user/scout_filtering/' + data.pk, data)
  },
  deleteScoutFiltering (id) {
    return session.delete(uri + '/api/user/scout_filtering/' + id)
  },
  // ScoutAutoSending API
  createScoutAutoSending (data) {
    return session.post(uri + '/api/user/scout_auto_sending/', data)
  },
  getScoutAutoSending (id) {
    if (id) return session.get(uri + '/api/user/scout_auto_sending/' + id)
    else return session.get(uri + '/api/user/scout_auto_sending/')
  },
  updateScoutAutoSending (data) {
    return session.patch(uri + '/api/user/scout_auto_sending/' + data.pk, data)
  },
  deleteScoutAutoSending (id) {
    return session.delete(uri + '/api/user/scout_auto_sending/' + id)
  },
  // 各種APIステータス取得
  getUsersStatusAPI () {
    return session.get(uri + '/api/user/get_users_status_api/')
  },
  getSelectedUsersStatusAPI (data) {
    return session.post(uri + '/api/user/get_selected_users_status_api/', data)
  },
  // 会社情報取得（Any）
  getCompanyAny (cid) {
    return session.get(uri + '/api/user/get_company/' + cid)
  },
  // 組織・役職エクスポート
  exportDepartment () {
    return session.get(uri + '/api/user/export_department/')
  },
  exportPosition () {
    return session.get(uri + '/api/user/export_position/')
  },
  // ユーザーインポート
  importUser (data) {
    return session.post(uri + '/api/user/import_user/', data)
  },
  // ユーザーエクスポート
  exportUser () {
    return session.get(uri + '/api/user/export_user/')
  },
  // ウェブセミナー案内
  sendEmailSeminarView (data) {
    return session.post(uri + '/api/user/send_email_seminar/', data)
  },
  // 従量課金状況
  payperuseInfo () {
    return session.get(uri + '/api/user/pay_per_use_info/')
  },
  billingDownload () {
    return session.get(uri + '/api/user/billing_download/')
  },
  // CompanyHomePage API
  createCompanyHomePage (data) {
    return session.post(uri + '/api/user/company_home_page/', data)
  },
  getCompanyHomePage (id) {
    if (id) return session.get(uri + '/api/user/company_home_page/' + id)
    else return session.get(uri + '/api/user/company_home_page/')
  },
  updateCompanyHomePage (data) {
    return session.patch(uri + '/api/user/company_home_page/' + data.id, data)
  },
  deleteCompanyHomePage (id) {
    return session.delete(uri + '/api/user/company_home_page/' + id)
  },
  deleteGaroon () {
    return session.delete(uri + '/api/user/delete_garoon/')
  },
  deleteCybozuOffice () {
    return session.delete(uri + '/api/user/delete_CybozuOffice/')
  },
  deleteLineWorks () {
    return session.delete(uri + '/api/user/delete_lineworks/')
  },
  createControlLog (payload) {
    return session.post(uri + '/api/user/user_control_log/', payload)
  },
  getControlLogList (filter) {
    return session.post(uri + '/api/user/user_control_log_list/', filter)
  },
  exportControlLogs (filter) {
    return session.post(uri + '/api/user/user_control_log_export/', filter)
  },
  getControlLogFilterItems () {
    return session.get(uri + '/api/user/user_control_log_filter_items/')
  },
  // 直近応募者に対して、自動採用フロー（応募者管理画面反映時）の停止可On/Off
  omitRecentApplicantDupflg(company_id, data) {
    return session.put(uri + '/api/user/omit_recent_applicant_dupflg/' + company_id, data);
  },
  getRecentApplicantDupflg(company_id) {
    return session.get(uri + '/api/user/omit_recent_applicant_dupflg/' + company_id);
  },
}



// WEBPACK FOOTER //
// ./src/api/auth.js